import { Controller } from "@hotwired/stimulus"

// Копіювання тексту (IBAN, призначення платежу) у буфер обміну.
// data-clipboard-text-value — що копіювати; кнопка коротко показує "Скопійовано!".
export default class extends Controller {
  static values = { text: String, copiedLabel: String }

  copy() {
    navigator.clipboard.writeText(this.textValue).then(() => {
      const original = this.element.innerHTML
      this.element.innerHTML = this.copiedLabelValue || "✓"
      this.element.classList.add("btn-success")
      setTimeout(() => {
        this.element.innerHTML = original
        this.element.classList.remove("btn-success")
      }, 1500)
    })
  }
}
